import { makeAutoObservable } from "mobx";
// import localforage from 'localforage';

class Auth {
    isInitializing = false;
    isLoggedIn = false;
    storage = null;

    constructor() {
        console.log('AUTH CONSTRUCTOR');
        makeAutoObservable(this);
        // this.storage = localforage.createInstance({ storeName: "auth" })
        // this.storage.getItem('jwt').then((v) => { if (v) this.isLoggedIn = true }).then(() => this.isInitializing = false)
    }

    login() {
        this.isInitializing = true;
        /*setTimeout(() => {
            this.storage.setItem('jwt', 'erwrqerwfadsaf134134rfsadfsdfsadf').then(() => {
                this.isLoggedIn = true;
                this.isInitializing = false;
                console.log('LOGIN');
            })
        }, 1000)
        */
    }

    logout() {
        this.isInitializing = false;
        /*
        this.storage.removeItem('jwt').then(() => {
            this.isLoggedIn = false;
        })
        */
    }
}

export default new Auth();